import React from 'react';
import { Link } from 'react-router-dom';

const ThankYouPage = () => {
  return (
    <main className="thank-you-page">
      <section className="thank-you-card">
        <p className="eyebrow">Request received</p>

        <h1>Thank you — we received your request.</h1>

        <p>
          We’ll review your team’s location, budget, group size, and goals, then
          send you <strong>personalized office outing ideas</strong> by email
          within 1 business day.
        </p>

        <div className="thank-you-next">
          <h3>What happens next?</h3>

          <ul>
            <li>We review your request personally.</li>
            <li>We match your team with strong outing options.</li>
            <li>You receive recommendations and next steps by email.</li>
          </ul>
        </div>

        <div className="coordination-offer">
          <p className="eyebrow">Optional planning support</p>

          <h3>Want us to help coordinate the details?</h3>

          <p>
            For teams that want extra support, Office Outing can help compare
            options, contact venues, check availability, and organize next steps.
          </p>

          <p className="coordination-price">
            Coordination support is available upon request.
          </p>

          <a
            href="mailto:serex27@gmail.com?subject=Office%20Outing%20Coordination%20Help&body=Hi%20Office%20Outing%2C%0A%0AI%20just%20submitted%20a%20request%20and%20I%27d%20like%20to%20learn%20more%20about%20coordination%20help.%0A%0ACompany%2Fteam%3A%20%0AApproximate%20date%3A%20%0AGroup%20size%3A%20%0A%0AThank%20you%21"
            className="button secondary"
          >
            Ask About Coordination Help
          </a>
        </div>

        <div className="thank-you-actions">
          <Link to="/" className="button primary">
            Return to Office Outing
          </Link>
        </div>
      </section>
    </main>
  );
};

export default ThankYouPage;
